import { Button, ButtonGroup, FormControl } from '@mui/material';
import { type ConjsProps } from '@react-awesome-query-builder/mui';

export default function MaterialConjs({
	id,
	not,
	setNot,
	conjunctionOptions = {},
	setConjunction,
	disabled,
	readonly,
	showNot,
	notLabel
}: ConjsProps) {
	const conjsCount = Object.keys(conjunctionOptions).length;
	const lessThenTwo = disabled;

	const renderOptions = () =>
		Object.keys(conjunctionOptions).map(key => {
			const { id: idx, label, checked } = conjunctionOptions[key];
			if (readonly && !checked) return null;
			return (
				<Button
					key={idx}
					id={idx}
					variant="contained"
					color={checked ? 'primary' : 'inherit'}
					value={key}
					onClick={onClick.bind(null, key)}
					disabled={readonly}
				>
					{label}
				</Button>
			);
		});

	const renderNot = () => {
		if (readonly && !not) return null;
		return (
			<Button
				key={id}
				id={`${id}__not`}
				variant="contained"
				color={not ? 'primary' : 'inherit'}
				onClick={onNotClick.bind(null, !not)}
				disabled={readonly}
				size="small"
			>
				{notLabel || 'NOT'}
			</Button>
		);
	};

	const onClick = value => setConjunction(value);
	const onNotClick = checked => setNot(checked);

	return (
		<FormControl>
			<ButtonGroup variant="outlined" size="small" disabled={readonly}>
				{showNot && renderNot()}
				{conjsCount > 1 && !lessThenTwo && renderOptions()}
			</ButtonGroup>
		</FormControl>
	);
}
